module.exports = __webpack_public_path__ + "static/media/logout.6d04a2bc.svg";